import React, { Component } from 'react';
import Axios from 'axios';
import { Container, Alert, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import Urls from '../../Services/Urls.js';
import { Redirect, withRouter } from 'react-router-dom';
import NumericInput from 'react-numeric-input';
import './ActivationsStatus.css'
import { ActivationsStatusTable } from '../Table/ActivationsStatusTable';


class ActivationsStatus extends Component {
    static displayName = ActivationsStatus.name;

    constructor(props) {
        super(props);
        this.state = {
            activationsStatus: null,
            pageNumber: 1,
            pageSize: 20,
            serialNumber: null,
            getActivationsStatusUrl: '',

            errorMessage: null,
            showError: false,

            loaded: true,
            error: false
        };
    }

    _updateError = (errorMessage) => {
        this.setState({
            showError: errorMessage !== null,
            errorMessage
        });
    }

    _onPageSizeChanged = (valueAsNumber, valueAsString) => {
        this.setState({
            pageSize: valueAsNumber
        });
    }

    _onGetActivationsStatusClicked = () => {
        this._getActivationsStatusFromServer();
        this._updateError(null);
    }

    _removeEmpty = obj => {
        Object.keys(obj).forEach(key => (obj[key] == null || obj[key] === '') && delete obj[key]);
    };

    _getActivationsStatusFromServer = () => {
        const urlParameters = {
            p: 'pageIndexPlaceholder',
            ps: this.state.pageSize,
            serialNumber: this.state.serialNumber
        };

        this._removeEmpty(urlParameters);
        const getActivationsStatusUrl = Urls.getActivationsStatus + '?' + new URLSearchParams(urlParameters).toString();
        this.setState({ getActivationsStatusUrl });
    }

    _getSearchBtnText = () => this.state.getActivationsStatusUrl === '' ? "Search activations" : "New Search";

    componentDidMount() {
        const token = localStorage.getItem("access_token");

        if (token) {
            const base64Url = token.split('.')[1]
            const base64 = base64Url.replace('-', '+').replace('_', '/')
            const { exp } = JSON.parse(window.atob(base64))
            if (Date.now() >= exp * 1000) {
                this.setState({ errorMessage: "Login timeout expired" });
                localStorage.removeItem("access_token");
                this.props.refreshNavMenu();
                this.props.history.push('/');
            }
        }
    }

    render() {
        if (!localStorage.getItem("access_token"))
            return <Redirect to='/login' />

        const activationsTable = this.state.getActivationsStatusUrl !== '' && <ActivationsStatusTable url={this.state.getActivationsStatusUrl} />

        return (
            <Container >
                <h1>Activations Status</h1>

                <ul>
                    <li><strong>Activations Status</strong> Here you can view the status of PLC activations.</li>
                </ul>

                <Form>
                    <FormGroup>
                        <Label for="specificSerialNumber">Insert a specific PLC serial number (optional - leave empty to see all)</Label>
                        <Input onChange={(event) => this.setState({ serialNumber: event.target.value })} type="text" id="specificSerialNumber" placeholder="Insert a specific PLC serial number" />
                    </FormGroup>

                    <FormGroup>
                        <Label for="pageSizeId">Enter the amount of records per page</Label>
                        <NumericInput id="pageSizeId" min={1} max={500} value={this.state.pageSize} onChange={this._onPageSizeChanged} />
                    </FormGroup>
                    <FormGroup>
                        <Button color="success" onClick={this._onGetActivationsStatusClicked}>{this._getSearchBtnText()}</Button>
                    </FormGroup>
                </Form>
                <Alert color="danger" fade={false} isOpen={this.state.showError}>
                    {this.state.errorMessage}
                </Alert>
                {activationsTable}
            </Container>
        );
    }
}

export default withRouter(ActivationsStatus);